import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * De ring-spinner van de pre-bootstrap splash (`index.html`) als herbruikbare
 * loader: een amber boog op een stille track met gloeiend middelpunt. Voor
 * inline gebruik kleiner dan de 100px startup-variant (via de `size`-input).
 */
@Component({
  selector: 'e-splash-loader',
  templateUrl: './e-splash-loader.component.html',
  styleUrl: './e-splash-loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ESplashLoaderComponent {
  /** Diameter van de spinner in px (startup-splash = 100; inline ±32–40). */
  readonly size = input(32);
}
